import axios from '@/plugins/axios';
import SystemConst from '@/shared/system-const';
import { TableFilters } from '@/components/common/common-table-filter.component';
import common from '@/shared/common-function';

export default {
    namespaced: true,

    state: {
        // 一覧画面用
        /** ページ */
        pageNation: 1,

        /** 表示件数 */
        itemsPerPage: SystemConst.LIST_LINES_PER_PAGE[1],

        /** フィルター条件 */
        filters: {},

        /** ソートカラム */
        sortBy: [],

        /** ソート昇順、降順 */
        sortDesc: [],

        /** 確認画面からの遷移フラグ */
        isFromConfirm: false
    },
    mutations: {
        /** セッター：state.pageNation */
        setPageNation(state: any, pageNation: number) {
            state.pageNation = pageNation;
        },

        /** セッター：state.itemsPerPage */
        setItemsPerPage(state: any, itemsPerPage: number) {
            state.itemsPerPage = itemsPerPage;
        },

        /** セッター：state.filters */
        setFilters(state: any, filters: TableFilters) {
            state.filters = filters;
        },

        /** セッター：state.sortBy */
        setSortBy(state: any, sortBy: string[]) {
            state.sortBy = sortBy;
        },

        /** セッター：state.sortDesc */
        setSortDesc(state: any, sortDesc: boolean[]) {
            state.sortDesc = sortDesc;
        },

        /** セッター：state.isFromConfirm */
        setIsFromConfirm(state: any, isFromConfirm: boolean) {
            state.isFromConfirm = isFromConfirm;
        },

        /** 
         * 処理依頼管理ストアのクリア
         * 
         * @param state ステートオブジェクト
         */
        clearStoreState(state: any) {
            state.pageNation = 1;
            state.itemsPerPage = SystemConst.LIST_LINES_PER_PAGE[1];
            state.filters = {};
            state.sortBy = [];
            state.sortDesc = [];
            state.isFromConfirm = false;
        }
    },

    actions: {

        // 処理依頼一覧取得API
        async getRequests({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-requests
            // params:ページ番号
            //        １ページあたりの行数
            //        ソートキー
            //        ソート順
            //        フィルタ情報
            await axios.get('/api/processing-requests',
                {
                    params: data,
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   processingRequests[]
            //   totalCount
            //   HTTPステータスコード
            return result;
        },

        // 処理依頼一覧フィルタ条件取得API
        async getFilterConditions() {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-requests/filter-conditions
            // params: なし
            await axios.get('/api/processing-requests/filter-conditions')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // 処理依頼削除API
        async deleteRequest({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:DELETE /api/processing-requests/{processRequestId}
            // processRequestId : 処理依頼ID
            await axios.delete(`/api/processing-requests/${data.processRequestId}`)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        },

        // 処理依頼確認取得API
        async getConfirmation({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-requests/{processRequestId}
            // processRequestId : 処理依頼ID
            await axios.get(`/api/processing-requests/${data.processRequestId}`)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   HTTPステータスコード
            //   processingRequest
            //   validateValues
            return result;

        },

        // 処理依頼確認ファイルダウンロード
        async download({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:GET /api/processing-requests/{processRequestId}/{fileDivision}/{fileSequence}
            // processRequestId : 処理依頼ID
            // fileDivision : ファイル区分('application' or 'attachment' or 'reply')
            // fileSequence : ファイルシーケンス(1,2,3,...) 
            await axios.get(`/api/processing-requests/${data.processRequestId}/${data.fileDivision}/${data.fileSequence}`,
                {
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    // 通信結果を設定
                    result = response;

                    // ダウンロードしたデータがあるか
                    if (response.data) {
                        const blob = new Blob([response.data]);
                        // BlobオブジェクトのURLオブジェクトを作成
                        const objURL: string = window.URL.createObjectURL(blob);

                        // aタグを作成し，クリックする
                        const dlLink: HTMLAnchorElement = document.createElement('a');
                        dlLink.href = objURL;
                        dlLink.download = common.getFileNameFromContentDisposition(response.headers['content-disposition']);

                        document.body.appendChild(dlLink); // 追加
                        dlLink.click();
                        document.body.removeChild(dlLink); // 削除
                    }
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                    // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                    const errorMessage = Array.from(new Uint8Array(error.response.data));

                    // 作成した文字コードを文字列に変換し、JSON形式に変換する
                    result.data = JSON.parse(String.fromCharCode.apply("", errorMessage));
                });

            // 通信結果を返す
            //   HTTPステータスコード
            //   (ファイルデータ)
            return result;
        },

        // 処理依頼確認更新
        async updateRequests({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // URL:POST /api/processing-requests/{processRequestId}
            // processRequestId : 処理依頼ID
            // 画面入力データ
            // 画面にドロップした返信ファイル
            const formData = new FormData();

            // 返信ファイル
            data.files.forEach((e: any) => {
                if (e instanceof File) {
                    formData.append('files[]', e, e.name);
                }
            });

            // 画面入力データ
            formData.append('processRequest', JSON.stringify(data.processRequest));

            await axios.post(
                `/api/processing-requests/${data.processRequestId}`, formData)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            //   HTTPステータスコード
            return result;
        }

    },
}
